import { useCallback } from 'react';
import { usePostNoteMutation } from '@customer/store/apis/investigationsApi';
import { useParams } from 'react-router-dom';
import AddNotePanel from '../components/add-note-panel/AddNotePanel';

export function AddInvestigationNotePanel() {
  const { investigationId } = useParams();

  const [postNote] = usePostNoteMutation();

  const onSubmitInternal = useCallback(
    async (text: string): Promise<boolean> => {
      if (typeof investigationId === 'undefined') return false;

      return await postNote({ id: investigationId, text }).then(response => {
        return response.error === undefined;
      });
    },
    [postNote, investigationId],
  );

  return (
    <AddNotePanel
      successTrans="PostInvestigationNoteSuccess"
      errorTrans="PostInvestigationNoteError"
      onSubmit={onSubmitInternal}
    />
  );
}

export default AddInvestigationNotePanel;
